<template lang="pug">
    div.query-filter
        // code {{ $store.state.dashboard.queryFilter }}
        Row
            Col.selectorCol(span="24")
                Row(:gutter="16")
                    Col.selectorCol(:lg="5" :md="8" v-if="isWithServiceGroupName")
                        ServiceGroupNameSelector

                    Col.selectorCol(:lg="5" :md="8" v-if="isWithServerName")
                        ServerNameSelector

                    Col.selectorCol(:lg="5" :md="8")
                        Button(@click="visible=!visible" type="dashed" icon="md-funnel") Advanced Filters

                    Col.selectorCol(:lg="5" :md="8" style="float: right" v-if="isWithDateRange")
                        DateRangeSelector(:customTimeRangeOptions="this.customTimeRangeOptions")
        Row
            Dropdown(trigger="custom" :visible="visible" style="margin-left: 20px")
                DropdownMenu(slot="list")
                    Card(dis-hover)
                        Row(:gutter="16")
                            Col.selectorCol(:lg="6" :md="12" v-if="isWithGroupName")
                                GroupNameSelector

                            Col.selectorCol(:lg="6" :md="12" v-if="isWithServiceGroupName")
                                ServiceGroupNameSelector

                            Col.selectorCol(:lg="6" :md="12" v-if="isWithTags")
                                TagSelector(:placeholder="$t('domainsetting.tags')")

                            Col.selectorCol(:lg="6" :md="12" v-if="isWithAppProfileName")
                                AppProfileNameSelector

                            Col.selectorCol(:lg="6" :md="12" v-if="isWithServerName")
                                ServerNameSelector

                            Col.selectorCol(:lg="6" :md="12" v-if="isWithOrigin")
                                OriginSelector

                            Col.selectorCol(:lg="6" :md="12" v-if="isWithSlbName")
                                SlbNameSelector

                            Col.selectorCol(:lg="6" :md="12" v-if="isWithEdgeName")
                                EdgeNameSelector

                            Col.selectorCol(:lg="6" :md="12" v-if="isWithLatencyStatusName")
                                LatencyStatusNameSelector

                            Col.selectorCol(:lg="6" :md="12" style="float: right" v-if="isWithDateRange")
                                DateRangeSelector(:customTimeRangeOptions="this.customTimeRangeOptions" :dateRangeLimit="this.dateRangeLimit")

                        div(style="text-align: right;margin:10px;")
                            SearchChartBtn(@click.native="setVisibleFalse")
                            Button(@click="resetQueryFilter") Reset
                            Button(@click="visible=false") Close
</template>

<script>
import { getFormOptions } from "@/api/formoptions";
import GroupNameSelector from "@/components/FormItems/GroupNameSelector";
import ServiceGroupNameSelector from "@/components/FormItems/ServiceGroupNameSelector";
import AppProfileNameSelector from "@/components/FormItems/AppProfileNameSelector";
import ServerNameSelector from "@/components/FormItems/ServerNameSelector";
import TagSelector from "@/components/FormItems/TagSelector";
import OriginSelector from "@/components/FormItems/OriginSelector";
import SlbNameSelector from "@/components/FormItems/SlbNameSelector";
import EdgeNameSelector from "@/components/FormItems/EdgeNameSelector";
import LatencyStatusNameSelector from "@/components/FormItems/LatencyStatusNameSelector";
import DateRangeSelector from "@/components/FormItems/DateRangeSelector";

export default {
    name: "DashboardQueryFilterV3",
    components: {
        GroupNameSelector,
        ServiceGroupNameSelector,
        AppProfileNameSelector,
        ServerNameSelector,
        TagSelector,
        OriginSelector,
        SlbNameSelector,
        EdgeNameSelector,
        LatencyStatusNameSelector,
        DateRangeSelector,
        SearchChartBtn: () => import("@/components/SearchChartBtn"),
    },
    data() {
        return { visible: false, originQueryFilter: {} };
    },
    props: {
        isWithGroupName: {
            type: Boolean,
            default: false,
        },
        isWithServiceGroupName: {
            type: Boolean,
            default: true,
        },
        isWithAppProfileName: {
            type: Boolean,
            default: true,
        },
        isWithServerName: {
            type: Boolean,
            default: true,
        },
        isWithTags: {
            type: Boolean,
            default: true,
        },
        isWithOrigin: {
            type: Boolean,
            default: true,
        },
        isWithSlbName: {
            type: Boolean,
            default: false,
        },
        isWithEdgeName: {
            type: Boolean,
            default: false,
        },
        isWithLatencyStatusName: {
            type: Boolean,
            default: false,
        },
        isWithDateRange: {
            type: Boolean,
            default: true,
        },
        customTimeRangeOptions: {
            type: Array,
        },
        dateRangeLimit: { type: Number, default: 90 },
    },
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {
        // 有人沒使用的話必須清空該欄位
        if (!this.isWithGroupName) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "groupNames", value: [] });

        if (!this.isWithServiceGroupName)
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serviceGroupNames", value: [] });

        if (!this.isWithAppProfileName)
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "appProfileNames", value: [] });

        if (!this.isWithServerName) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serverNames", value: [] });

        if (!this.isWithOrigin) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "originHosts", value: [] });

        if (!this.isWithSlbName) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "slbNames", value: [] });

        if (!this.isWithEdgeName) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "edgeNames", value: [] });

        if (!this.isWithLatencyStatusName)
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "latencyStatusNames", value: [] });

        this.originQueryFilter = Object.assign({}, this.$store.state.dashboard.queryFilter);
    },
    methods: {
        resetQueryFilter() {
            var queryGroupName = this.$store.state.queryGroupName !== "all" ? [this.$store.state.queryGroupName] : [];
            this.$store.commit("RESET_DASHBOARD_QUERY_FILTER", queryGroupName);
            // if (this.$store.state.queryGroupName === "all") {
            //     this.originQueryFilter.groupNames = []
            // }
            // // this.originQueryFilter.serverNames = []
            // this.$store.commit("SET_DASHBOARD_QUERY_FILTER_FULL", this.originQueryFilter);
        },
        setVisibleFalse() {
            this.visible = false;
        },
    },
    computed: {},
};
</script>
<style scoped>
.selectorCol {
    margin-bottom: 5px;
}
.query-filter >>> .ivu-select-dropdown {
    /* width: 200px; */
    width: auto;
}
.query-filter >>> .ivu-dropdown {
    width: 100%;
}
.query-filter >>> .ivu-card-body {
    /* width: 800px; */
    width: calc(70vw - 60px);
}

.query-filter >>> .vs--searchable .vs__dropdown-toggle {
    cursor: text;
    border-radius: 10px;
    border-width: 2px;
}
.query-filter >>> ::-webkit-input-placeholder {
    color: rgb(165, 165, 165) !important;
}
.query-filter >>> ::-moz-placeholder {
    color: rgb(165, 165, 165) !important;
}
.query-filter >>> :-moz-placeholder {
    color: rgb(165, 165, 165) !important;
}
.query-filter >>> :-ms-input-placeholder {
    color: rgb(165, 165, 165) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardQueryFilterV3.vue